import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { StepIndicator } from 'frontend-utils';
import GeneralNavigationIntercomHelpLink from 'lumen/components/general/navigation/intercom-help-link';

interface HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderHeaderSignature {
  Args: {
    currentStep: number;
  };
}

const HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderHeader =
  <template>
    <div class="smart-compset__builder__header">
      <div class="smart-compset__builder__header__title">{{t
          "benchmark_insight.smart-compset.builder.title"
        }}</div>
      <div class="smart-compset__builder__header__step-indicator">
        <StepIndicator @currentStep={{@currentStep}} @steps={{3}} />
      </div>
      <div class="smart-compset__builder__header__actions">
        <GeneralNavigationIntercomHelpLink
          @articleLink="en/articles/9436312-your-guide-to-smart-compsets"
          @iconName="link-out"
          @linkText={{t "general.help_center"}}
          @type="text-and-icon"
        />
      </div>
    </div>
  </template> satisfies TOC<HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderHeaderSignature>;

export default HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderHeader;
